module.exports = __webpack_public_path__ + "img/DW365-152.0c6ad255.jpg";